import * as Yup from 'yup';

import { ResultViewModel } from './common/ResultViewModel';
import { TableViewModel } from './common/TableViewModel';

export const salesTaxRateValidation = Yup.object().shape({
  rate: Yup.number().typeError('Input a number').required('Rate is required'),
  effectiveDate: Yup.string().required('Effective Date is required'),
});

export interface SalesTaxRateViewModel {
  id: number;
  effectiveDate: string;
  rate: number;
  salesTaxId: number;
}

// Sales Tax Result View Models
export interface SalesTaxRateTableResultViewModel
  extends TableViewModel,
    ResultViewModel {
  data: SalesTaxRateViewModel[];
}

export interface SalesTaxRateListResultViewModel extends ResultViewModel {
  data: SalesTaxRateViewModel[];
}

// Sales Tax Model Default Initializer
export const salesTaxRateDefaultValue: SalesTaxRateViewModel = {
  id: 0,
  effectiveDate: '',
  rate: 0,
  salesTaxId: 0,
};

export const salesTaxRateTableDefaultValue: SalesTaxRateTableResultViewModel = {
  data: [],
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
  isSuccess: true,
  errorMessages: [],
};
